import { openModal } from '@core/components/ModalStack';
import { TimeMaterialOverlayProps } from './TimeMaterialOverlay';

export async function openTimeMaterialOverlay(props: TimeMaterialOverlayProps) {
  const { TimeMaterialOverlay } = await import('./TimeMaterialOverlay');

  openModal(TimeMaterialOverlay, props);
}
